var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDarkRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#323555"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28.374 32h-4.4V11.244h-1.965c-3.598 0-5.48 1.714-5.48 4.273 0 2.9 1.3 4.246 3.985 5.96l2.214 1.424L16.362 32H11.63l5.729-8.123c-3.294-2.242-5.148-4.43-5.148-8.123 0-4.615 3.377-7.754 9.77-7.754h6.365v24h.028z",
  fill: "#fff"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiMzMjM1NTUiLz4KPHBhdGggZD0iTTI4LjM3NDEgMzJIMjMuOTczNVYxMS4yNDRIMjIuMDA4NUMxOC40MTA2IDExLjI0NCAxNi41Mjg2IDEyLjk1ODIgMTYuNTI4NiAxNS41MTY1QzE2LjUyODYgMTguNDE3NiAxNy44Mjk0IDE5Ljc2MjYgMjAuNTE0IDIxLjQ3NjlMMjIuNzI4MSAyMi45MDExTDE2LjM2MjUgMzJIMTEuNjI5OUwxNy4zNTg5IDIzLjg3NjlDMTQuMDY1NCAyMS42MzUyIDEyLjIxMTEgMTkuNDQ2MiAxMi4yMTExIDE1Ljc1MzhDMTIuMjExMSAxMS4xMzg1IDE1LjU4NzYgOCAyMS45ODA4IDhIMjguMzQ2NFYzMkgyOC4zNzQxWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgDarkRounded as ReactComponent };